import { createSlice } from "@reduxjs/toolkit";
import { getUserDetails, getUserFriends } from "./usersAction";

const initialState = {
  userDataLoading: false,
  userData: {},
  userDataError: null,

  friendLoading: false,
  userFriends: [],
  friendError: null,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setFriendShipStatus: (state, action) => {
      state.userData.friendshipStatus = action.payload
    },
    setBlockStatus: (state, action) => {
      state.userData.isBlocked = action.payload
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getUserDetails.pending, (state) => {
        state.userDataLoading = true;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.userDataLoading = false;
        state.userData = action.payload;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.userDataLoading = false;
        state.userDataError = action.error.message;
      });


    builder
      .addCase(getUserFriends.pending, (state) => {
        state.friendLoading = true
        state.userFriends = initialState.userFriends
      })
      .addCase(getUserFriends.fulfilled, (state, action) => {
        state.friendLoading = false
        state.userFriends = action.payload
      })
      .addCase(getUserFriends.rejected, (state, action) => {
        state.friendLoading = false
        state.friendError = action.error.message
      })
  },
});

export const { setFriendShipStatus, setBlockStatus } = usersSlice.actions
export default usersSlice.reducer;
